module.exports = "<button type=\"button\" class=\"button-transparent\" (click)=\"onClick()\">\n    Добавить специалиста\n</button>"